import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { DatePicker } from 'antd';
import dayjs from 'dayjs'
import common from '../common.module.css'

export const StartDate = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    const onChange = (date, dateString) => {
      setFieldInState({field: 'start_date', value: dateString})
    };
    
    return (
      <DatePicker 
        value={state.start_date ? dayjs(state.start_date, 'YYYY-MM-DD') : null}
        className={common.antd}
        onChange={onChange} 
        placeholder="Выберите дату начала"  
      />
    );
}